import styled from 'styled-components';
import { cssVars } from '../../../shared/lib/styledTheme';

export const LoginPageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${cssVars.bgColor};
  padding: 20px;
`;

export const LoginPageCard = styled.div`
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  padding: 32px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const LoginPageTitle = styled.h1`
  margin: 0 0 24px 0;
  font-size: 24px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  text-align: center;
`;

export const LoginPageInfo = styled.div`
  padding: 12px;
  border-radius: 6px;
  border: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgTertiary};
  color: ${cssVars.textSecondary};
  font-size: 14px;
  line-height: 1.5;
`;

export const LoginPageStatus = styled.div`
  margin-top: 12px;
  color: ${cssVars.textSecondary};
  font-size: 14px;
  text-align: center;
`;

export const LoginPageForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LoginPageField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LoginPageLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
`;

export const LoginPageError = styled.div`
  padding: 12px;
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid ${cssVars.error};
  border-radius: 4px;
  color: ${cssVars.error};
  font-size: 14px;
`;

export const LoginPageActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

export const LoginPageSwitch = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${cssVars.textSecondary};
  margin-top: 16px;
`;

export const LoginPageLink = styled.span`
  color: ${cssVars.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${cssVars.primaryHover};
  }
`;
